import FormHandler from "formhandler.js";
import IMask from "imask";

export default {
    init() {


        const codeMaskElement = document.querySelector(
            "[data-imask='gift-code']"
        );
		decodeURI(codeMaskElement);
        const giftCodeSubmit = document.querySelector(".js-gift-code-submit");

        giftCodeSubmit.addEventListener('click', function(event) {
                event.preventDefault();
            }
        );

        this.maskGiftCode(codeMaskElement);

        this.handleForm();
    },

    maskGiftCode(element) {
        const giftCodemaskOptions = {
            mask: "####-####-####-####",
            prepare: function(str) {
                return str.toUpperCase();
            },
            definitions: {
                "#": /[a-zA-Z0-9]/
            }
        };

        const giftCodeMask = IMask(element, giftCodemaskOptions);
    },

    handleForm() {
        const $this = this;
        const giftCodeFormHandler = new FormHandler({
            form: {
                block: ".js-gift-code-form",
                submit: ".js-gift-code-submit",
                delayForNotice: 100000,
                notice: {
                    appendTo: ".js-gift-code-notices",
                    message: "Form is invalid. Please check your details and try again.",
                    succesMessage: "Form successfully sent.",
                    errorMessage: "Oops, something went wrong. Please try again later.",
                }
            },
            fields: {
                "code": {
                    validation: "isNonEmpty",
                    min: 19
				},
				user_id: {
					validation: "isNonEmpty"
				}
			},
			callbacks: {
				onSubmit(form, fields) {
					testValidity(form);
				},
			},
        });

        function testValidity(form) {
            if(giftCodeFormHandler.isFormValid() === true) {
                $this.submit(form);
            }
        }

    },

    submit(form) {
        form.submit()
    }
};
